import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useSelector } from "react-redux";

import LoadingSpinner from "Components/UI/LoadingSpinner";

import { DatePicker, message, Table, Alert, Spin, Select } from "antd";
const { RangePicker } = DatePicker;
import TableTop from "Components/UI/TableTop";
import { useGetAttendanceListingQuery } from "AppQuries/attendance/attendance-listing";
import { format } from "date-fns";

const attendanceTypeOptions = [
  {
    label: "Break",
    value: "4",
  },
  {
    label: "Absent > 3 Days",
    value: "1",
  },
];

const AttendanceListing = () => {
  const userData = useSelector(loggedInUser);
  const [isMount, setIsMount] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const [attendanceListingType, setAttendanceListingType] = useState(
    searchParams.get("status") ?? 0,
  );

  const {
    data: attendanceData,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: fetchAttendance,
  } = useGetAttendanceListingQuery({
    status: attendanceListingType,
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    userId: userData?.userID,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
  });

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      key: "uniqueID",
    },
    {
      title: "Emp Name",
      dataIndex: "employeeName",
      key: "employeeName",
    },
    {
      title: "Department Code",
      dataIndex: "departmentName",
      key: "departmentName",
    },
    ...(attendanceListingType === "4"
      ? [
          {
            title: "Attendance Date",
            dataIndex: "attendanceDate",
            key: "attendanceDate",
            render: (text, record) => (
              <>{format(new Date(text), "dd-MM-yyyy")}</>
            ),
          },
          {
            title: "Break In Time",
            dataIndex: "breakInTime",
            key: "breakInTime",
          },
        ]
      : []),
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    attendanceData,
    searchColumns,
  );

  useEffect(() => {
    if (!attendanceListingType) return;

    const params = new URLSearchParams(searchParams);

    params.set("status", attendanceListingType);

    setSearchParams(params);
    fetchAttendance();
  }, [attendanceListingType]);

  if (isLoading || isFetching) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Attendance Summary</h4>
                <h6>Manage your employees attendance</h6>
              </div>
            </div>
            <div className="page-btn">
              <Select
                options={attendanceTypeOptions}
                placeholder="Select Attendance Type"
                className={`select`}
                value={attendanceTypeOptions.find(
                  (option) => option.value === attendanceListingType,
                )}
                onChange={(selectedOption) => {
                  console.log(selectedOption);
                  setAttendanceListingType(selectedOption);
                }}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    width: "200px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>

            {/* <div className="page-btn">
              <button
                className="btn btn-defalut"
                type="button"
                onClick={onAttendanceExcelDownload}
              >
                <Upload className="me-2" />
              </button>
            </div> */}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="table-list-card mt-2">
                <TableTop
                  onSearch={setSearchValue}
                  searchValue={searchValue}
                  toggleFilterVisibility={toggleFilterVisibility}
                  showToggle={false}
                  isFilterVisible={isFilterVisible}
                />
                <div className="table-responsive">
                  <Spin size="large" spinning={isLoading || isFetching}>
                    <Table
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                      pagination={true}
                      rowKey="employeeCode"
                    />
                    {isError && <Alert message={error} type="error" />}
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AttendanceListing;
